const translations = {
    en: {
        nav: {
            home: "Home",
            about: "About",
            lipoedeme: "Le Lipœdème",
            actions: "Our Actions",
            adhesion: "Membership",
            news: "News",
            contact: "Contact"
        },
        newsPage: {
            title: "News",
            comingSoon: "Coming Soon",
            description: "We are currently working on this page to bring you the latest news and updates on Lipedema. Stay tuned!",
            backHome: "Back to Home"
        },
        footer: {
            address: "7, rue Ahmed Annaciri – Palmier, 20100 Casablanca",
            email: "Lipoedememaroc@gmail.com",
            phone: "+212 6 66 01 39 59",
            rights: "All rights reserved © {year} MOSLIPOD"

        },
        home: {
            hero: {
                badge: "Recognize • Manage • Raise Awareness",
                title1: "Recognize",
                title2: "Lipedema",
                description: "The Moroccan Lipedema Society works for the recognition, management and awareness of a chronic pathology recognized by the WHO since 1945 affecting about 11% of the population, mostly women.",
                cta1: "Discover Lipedema",
                cta2: "Who are we?"
            },
            whatIs: {
                title: "What is Lipedema?",
                subtitle: "A chronic, progressive and often underdiagnosed condition",
                cards: {
                    sym: "Symmetrical\nAccumulation",
                    pain: "Painful\non Palpation",
                    weight: "Not Influenced\nby Weight",
                    spared: "Hands & Feet\nSpared"
                },
                description: "Lipedema is characterized by a pathological accumulation of subcutaneous adipose tissue, mainly located in the lower limbs. This condition progresses slowly and affects about 11% of the world population, mostly women.",
                cta: "Learn More"
            }
        },
        about: {
            hero: {
                badge: "Founded in 2025 in Casablanca",
                title: "About MOSLIPOD",
                subtitle: "A non-profit medical association dedicated to the recognition, professional training and awareness of lipedema"
            },
            genesis: {
                title: "Genesis",
                content: [
                    "Created in 2025 in Casablanca, the Moroccan Society of Lipedema and Associated Pathologies is a non-profit medical association, working for scientific recognition, professional training, public awareness and the improvement of the management of lipedema.",
                    "This learned society was born under the impulse of Dr. Fahd Benslimane, a plastic surgeon who has been treating patients showing symptoms of lipedema for more than two decades, well before the pathology was formally identified.",
                    "Aware of the multidimensional complexity of this condition — inflammatory, metabolic, vascular, nutritional and psychological — the association has brought together a multidisciplinary college of doctors and experts, committed to an integrative approach based on international recommendations."
                ],
                year: "2025",
                yearTitle: "Founding Year",
                location: "Casablanca, Morocco"
            },
            objectives: {
                title: "Our 6 Major Objectives",
                subtitle: "An ambitious roadmap to transform the management of lipedema",
                items: [
                    { title: "Information and Awareness", desc: "Inform the Moroccan population about lipedema with scientific educational tools. Make this pathology recognized by the WHO since 1945 known." },
                    { title: "Promotion of Management", desc: "Promote an early, multidisciplinary and integrative approach based on validated non-surgical treatments." },
                    { title: "Training and Communication", desc: "Train health professionals from the public and private sectors to avoid comorbidities." },
                    { title: "Research and Expertise", desc: "Lead or participate in clinical and epidemiological studies and provide scientific expertise." },
                    { title: "Collaboration and Advocacy", desc: "Collaborate with ministries, national and international health organizations for public policies." },
                    { title: "Events and Publications", desc: "Organize conferences, training sessions and publish manuals, brochures and scientific supports." }
                ]
            },
            team: {
                title: "Founding Board Members",
                subtitle: "A team of doctors and experts committed to a multidisciplinary approach",
                members: [
                    { name: "Dr Fahd Benslimane", role: "President", specialty: "Plastic Surgeon", desc: "Expert in Plastic and aesthetic surgery. Initiator of the society, recognized for his commitment to the recognition of lipedema." },
                    { name: "Pr Jaafar Heikel", role: "Vice-President", specialty: "Nutritionist & Epidemiologist", desc: "University professor, international consultant and health policy expert. Brings a strategic and population vision." },
                    { name: "Pr El Harti Amine", role: "General Secretary", specialty: "Associate Professor in Plastic and Aesthetic Surgery", desc: "Expert at the Faculty of Medicine of Casablanca. Member of the National Expert Group for specialized training. Contributes to clinical protocols and academic links." },
                    { name: "Dr Karim Benjelloun", role: "Treasurer", specialty: "Anesthesiologist-Resuscitator", desc: "His expertise in anesthesia and therapeutic nutrition strengthens global management." },
                    { name: "Dr Raghni Salwa", role: "Assessor 1", specialty: "General Practitioner", desc: "In charge of early detection and diagnostic guidance for patients in first-line care." },
                    { name: "Dr Belmallem Imane", role: "Assessor 2", specialty: "Pulmonologist & Allergist", desc: "Specialized in respiratory and inflammatory disorders. Contributes to the analysis of associated comorbidities." },
                    { name: "Dr Mohammed Taha", role: "Assessor 3", specialty: "Sports Doctor", desc: "Designs adapted physical activity (APA) programs for patients with lipedema." }
                ]
            },
            stats: {
                title: "Association Statutes",
                subtitle: "Consult and download the official statutes of the Moroccan Lipedema Society",
                description: "The full statutes of MOSLIPOD detail the governance, goals, rights and obligations of members, as well as all regulatory provisions of the association.",
                cta: "Download Statutes (PDF)",
                info: "PDF Format • Updated 2025 • Available immediately"
            },
            cta: {
                title: "Join Our Mission",
                subtitle: "Whether you are a healthcare professional, patient or simply interested in our cause, find out how you can support MOSLIPOD",
                button1: "Discover MOSLIPOD",
                button2: "Back to Home"
            }
        },
        lipoedeme: {
            hero: {
                badge: "Understanding the pathology",
                title: "Lipedema",
                subtitle: "A chronic, progressive and debilitating pathology that requires global and caring management"
            },
            definition: {
                title: "What is Lipedema?",
                p1: "Lipedema is a chronic, progressive and still misunderstood pathology, characterized by an excessive accumulation of subcutaneous adipose tissue, mainly located at the hips, thighs, knees, legs, and sometimes arms.",
                p1High: " excessive accumulation of subcutaneous adipose tissue",
                p2: "Unlike obesity, this accumulation is symmetrical, painful, not influenced by caloric restriction, and does not affect the extremities (hands or feet).",
                p2High: "symmetrical, painful, not influenced by caloric restriction",
                omsTitle: "WHO Recognition",
                omsDesc: "Recognized by the WHO since 1945 as a debilitating condition, it affects almost exclusively women, often after a hormonal imbalance (puberty, pregnancy, menopause). Despite this, it remains largely under-diagnosed in clinical practice.",
                omsHigh: " under-diagnosed"
            },
            symptoms: {
                title: "Symptoms",
                subtitle: "Recognize the clinical manifestations of lipedema for early management",
                items: [
                    { title: "Spontaneous or pressure pain", desc: "Discomfort in affected areas, independent of physical activity" },
                    { title: "Heavy legs sensation", desc: "Persistent tension sensation, even at rest" },
                    { title: "Frequent bruising", desc: "Capillary fragility without obvious trauma" },
                    { title: "Nodular appearance of adipose tissue", desc: "Irregular structure and deformation" },
                    { title: "Marked disproportion", desc: "Between the trunk (often thin) and the lower and sometimes upper limbs" },
                    { title: "Resistance to diets", desc: "No improvement despite dietary efforts and exercise" }
                ],
                psych: {
                    title: "Psychological Impact",
                    desc: "Patients often mention a significant psychological impact: isolation, anxiety, lower self-esteem. Caring and multidisciplinary management is essential.",
                    high: "multidisciplinary"
                }
            },
            treatments: {
                title: "Therapeutic Approaches",
                subtitle: "Non-surgical solutions adapted to your situation",
                conservative: [
                    { title: "Adapted physical activity", desc: "Water walking, cycling, gentle Pilates" },
                    { title: "Compression garments", desc: "Medical compression stockings or leggings" },
                    { title: "Manual lymphatic drainage", desc: "By a trained professional (MLD)" },
                    { title: "Intermittent pressotherapy", desc: "Stimulation of circulation" },
                    { title: "Localized cryotherapy", desc: "In a specialized center" },
                    { title: "Anti-inflammatory diet", desc: "Reduction of sugar, processed foods, omega-3" }
                ],
                surgical: {
                    title: "Surgical Approaches",
                    p1: "There is no definitive curative treatment. However, for severe forms, specialized medical liposuction can be considered, reserved for expert centers and framed by multidisciplinary follow-up.",
                    p1High1: "severe forms",
                    p1High2: " multidisciplinary follow-up",
                    p2: "This approach uses gentle techniques (under tumescence or water jet) and must be accompanied by integrative management including general practitioners, vascular specialists, physiotherapists, nutritionists, and psychologists."
                }
            },
            stages: {
                title: "The Stages of Lipedema",
                items: [
                    { title: "Stage 1", desc: "The skin surface is smooth. The subcutaneous adipose tissue is thickened, but the structure is soft." },
                    { title: "Stage 2", desc: "The skin surface becomes irregular. The adipose tissue has a nodular (orange peel) appearance." },
                    { title: "Stage 3", desc: "Significant accumulation of adipose tissue. Large, deforming fat lobes especially at the hips and knees." }
                ]
            },
            cta: {
                title: "You are not alone",
                subtitle: "MOSLIPOD is here to accompany you, inform you and guide you towards adapted resources. Contact us to learn more about treatment options and specialized centers.",
                button1: "Contact Us",
                button2: "Join MOSLIPOD"
            }
        },
        actions: {
            hero: {
                badge: "Our Commitment",
                title: "Our Actions for Change",
                subtitle: "Three major axes to transform the recognition and management of lipedema on a national scale"
            },
            discoverMore: "Discover more",
            items: [
                {
                    title: "Awareness",
                    description: "Information campaign for the general public and professionals",
                    details: [
                        "Diffusion of reliable educational content",
                        "Deconstruction of common misconceptions",
                        "Partnerships with medical institutions",
                        "Targeted supports for professionals"
                    ]
                },
                {
                    title: "Training",
                    description: "Continuing medical training day in 2026",
                    details: [
                        "Training of general practitioners",
                        "Practical clinical tools",
                        "Presentation of diagnostic criteria",
                        "Experience exchange and networking"
                    ]
                },
                {
                    title: "Information",
                    description: "Creation and dissemination of tools for caregivers",
                    details: [
                        "Practical diagnostic sheets",
                        "Continuing training supports",
                        "Videos and infographics",
                        "Guides for medical offices"
                    ]
                }
            ],
            stats: [
                { number: "2025", label: "Founding year" },
                { number: "7", label: "Founding experts" },
                { number: "3", label: "Action axes" }
            ],
            cta: {
                title: "Get Involved in Our Mission",
                subtitle: "Join our community of committed professionals to transform the recognition and management of lipedema",
                button1: "Become a member",
                button2: "Contact us"
            }
        },
        membership: {
            hero: {
                badge: "Join our community",
                title: "Become a Member of MOSLIPOD",
                subtitle: "Join our community of healthcare professionals committed to the recognition, research and management of lipedema"
            },
            learnMore: "Learn more",
            intro: "MOSLIPOD is open to Moroccan and foreign healthcare professionals wishing to commit to the recognition, research and management of lipedema.",
            types: {
                title: "Membership Types",
                active: {
                    name: "Active Members",
                    badge: "Principal",
                    requirements: [
                        "Be registered with the Medical Council (Morocco)",
                        "Be sponsored by two active members",
                        "Adhere to the statutes and regulations",
                        "Be approved and elected in General Assembly",
                        "Pay the annual membership fee"
                    ]
                },
                candidate: {
                    name: "Candidate Members",
                    badge: "Access",
                    requirements: [
                        "Young doctors wishing to join",
                        "Be registered with the Medical Council",
                        "Be sponsored by two members",
                        "Status valid for up to 5 years maximum",
                        "Can progress to active member"
                    ]
                },
                honorary: {
                    name: "Honorary Members",
                    badge: "Honor",
                    requirements: [
                        "Former members who have ceased activity",
                        "On sponsored written request",
                        "Approved by vote (2/3 majority)",
                        "Exempt from membership fee",
                        "No voting rights"
                    ]
                },
                foreign: {
                    name: "Foreign Members",
                    badge: "International",
                    requirements: [
                        "Foreign healthcare professionals",
                        "Members of their national society",
                        "Activity related to lipedema",
                        "Sponsored by members for 5+ years",
                        "Commitment to the charter"
                    ]
                }
            },
            process: {
                title: "Membership Process",
                steps: [
                    { title: "Application", desc: "Submit your complete file according to the modalities" },
                    { title: "Sponsorship", desc: "Obtain the support of two active members" },
                    { title: "Committee", desc: "Examination of your application by the Committee" },
                    { title: "Assembly", desc: "Election vote in General Assembly" },
                    { title: "Confirmation", desc: "Welcome as a member of MOSLIPOD!" }
                ]
            },
            cta: {
                title: "Ready to join us?",
                subtitle: "Contact us for more information on membership modalities and start your journey with us",
                button1: "Contact Us",
                button2: "Back to Home"
            }
        },
        contactPage: {
            hero: {
                badge: "Let's talk",
                title: "Get in Touch",
                subtitle: "Our team is here to answer your questions and support you. Do not hesitate to contact us."
            },
            form: {
                firstName: "First Name *",
                lastName: "Last Name *",
                organisation: "Organization",
                countryCode: "Code *",
                phone: "Phone *",
                email: "Email *",
                subject: "Subject *",
                message: "Message *",
                send: "Send Message",
                newsletter: "I agree to receive the association's newsletter",
                submit: "Send Message",
                sending: "Sending...",
                success: "Message sent! We will get back to you soon."
            },
            info: {
                title: "Contact Information",
                subtitle: "Direct means of communication with our association",
                addressTitle: "Our Office",
                phoneTitle: "Phone",
                emailTitle: "Email"
            }
        },
        privacy: {
            title: "Privacy Policy",
            subtitle: "Last updated: Feb 2026",
            intro: "At MOSLIPOD, we prioritize the protection of your personal data. This policy details how we collect, use, and protect your information.",
            collection: {
                title: "Data Collection",
                content: "We collect information you provide directly to us (name, email, etc.) when you fill out forms or subscribe to our newsletter."
            },
            usage: {
                title: "Use of Data",
                content: "Your data is used to communicate with you, manage your membership, and send you information about our activities."
            },
            protection: {
                title: "Data Protection",
                content: "We implement security measures to protect your data from unauthorized access or disclosure."
            },
            rights: {
                title: "Your Rights",
                content: "You have the right to access, correct, or delete your personal data. Contact us at Lipoedememaroc@gmail.com for any requests."
            }
        },
        legal: {
            title: "Legal Mentions",
            subtitle: "General Information",
            editor: {
                title: "Site Editor",
                content: "MOSLIPOD (Moroccan Society of Lipedema)\n7, rue Ahmed Annaciri – Palmier\n20100 Casablanca\nMorocco\nEmail: Lipoedememaroc@gmail.com\nPhone: +212 6 66 01 39 59"
            },
            hosting: {
                title: "Hosting",
                content: "This site is hosted by KYBOHO, located at 44 Avenue Mohammed Ben Abdellah, Fes."
            },
            ip: {
                title: "Intellectual Property",
                content: "All content on this site (text, images, logos) is the property of MOSLIPOD or its partners and is protected by copyright laws."
            }
        }
    },
    fr: {
        nav: {
            home: "Accueil",
            about: "À propos",
            lipoedeme: "Le Lipœdème",
            actions: "Nos actions",
            adhesion: "Adhésion",
            news: "Actualités",
            contact: "Contact"
        },
        newsPage: {
            title: "Actualités",
            comingSoon: "Bientôt Disponible",
            description: "Nous travaillons actuellement sur cette page pour vous apporter les dernières nouvelles et mises à jour sur le lipœdème. Restez connectés !",
            backHome: "Retour à l'accueil"
        },
        footer: {
            address: "7, rue Ahmed Annaciri – Palmier, 20100 Casablanca",
            email: "Lipoedememaroc@gmail.com",
            phone: "+212 6 66 01 39 59",
            rights: "Tous droits réservés © {year} MOSLIPOD"

        },
        home: {
            hero: {
                badge: "Reconnaitre • Prendre en charge • Sensibiliser",
                title1: "Reconnaitre le",
                title2: "Lipœdème",
                description: "La Société Marocaine du Lipœdème œuvre pour la reconnaissance, la prise en charge et la sensibilisation d'une pathologie chronique reconnue par l’OMS depuis 1945 touchant environ 11% de la population, majoritairement des femmes.",
                cta1: "Découvrir le Lipœdème",
                cta2: "Qui sommes-nous ?"
            },
            whatIs: {
                title: "Qu'est-ce que le Lipœdème ?",
                subtitle: "Une affection chronique, progressive et souvent sous-diagnostiquée",
                cards: {
                    sym: "Accumulation\nSymétrique",
                    pain: "Douloureuse\nà la Palpation",
                    weight: "Non Influencée\npar le Poids",
                    spared: "Mains & Pieds\nÉpargnés"
                },
                description: "Le lipœdème est caractérisé par une accumulation pathologique de tissu adipeux sous-cutané, principalement localisée aux membres inférieurs. Cette condition progresse lentement et affecte environ 11% de la population mondiale, majoritairement des femmes.",
                cta: "En Savoir Plus"
            }
        },
        about: {
            hero: {
                badge: "Fondée en 2025 à Casablanca",
                title: "À Propos de MOSLIPOD",
                subtitle: "Une association médicale à but non lucratif dédiée à la reconnaissance, la formation professionnelle et la sensibilisation autour du lipœdème"
            },
            genesis: {
                title: "Genèse",
                content: [
                    "Créée en 2025 à Casablanca, La Société Marocaine du Lipœdème et des Pathologies Associées est une association médicale à but non lucratif, œuvrant pour la reconnaissance scientifique, la formation professionnelle, la sensibilisation du public et l'amélioration de la prise en charge du lipœdème.",
                    "Cette société savante est née sous l'impulsion du Dr Fahd Benslimane, chirurgien plasticien qui traite depuis plus de deux décennies des patientes présentant les symptômes du lipœdème, bien avant que la pathologie ne soit formellement identifiée.",
                    "Consciente de la complexité multidimensionnelle de cette affection — inflammatoire, métabolique, vasculaire, nutritionnelle et psychologique — l'association a réuni un collège pluridisciplinaire de médecins et experts, engagés dans une approche intégrative fondée sur les recommandations internationales."
                ],
                year: "2025",
                yearTitle: "Année de Fondation",
                location: "Casablanca, Maroc"
            },
            objectives: {
                title: "Nos 6 Objectifs Majeurs",
                subtitle: "Une feuille de route ambitieuse pour transformer la prise en charge du lipœdème",
                items: [
                    { title: "Information et Sensibilisation", desc: "Informer la population marocaine sur le lipœdème avec des outils éducatifs scientifiques. Faire connaître cette pathologie reconnue par l'OMS depuis 1945." },
                    { title: "Promotion de la Prise en Charge", desc: "Valoriser une approche précoce, multidisciplinaire et intégrative reposant sur des traitements non chirurgicaux validés." },
                    { title: "Formation et Communication", desc: "Former les professionnels de santé des secteurs public et privé pour éviter les comorbidités." },
                    { title: "Recherche et Expertise", desc: "Mener ou participer à des études cliniques, épidémiologiques et fournir des expertises scientifiques." },
                    { title: "Collaboration et Plaidoyer", desc: "Collaborer avec les ministères, organismes de santé nationaux et internationaux pour les politiques publiques." },
                    { title: "Événements et Publications", desc: "Organiser colloques, formations et publier des manuels, brochures et supports scientifiques." }
                ]
            },
            team: {
                title: "Membres du Bureau Fondateur",
                subtitle: "Une équipe de médecins et experts engagés dans une approche multidisciplinaire",
                members: [
                    { name: "Dr Fahd Benslimane", role: "Président", specialty: "Chirurgien Plasticien", desc: "Expert en chirurgie  plastique et esthétique. Initiateur de la société, reconnu pour son engagement dans la reconnaissance du lipœdème." },
                    { name: "Pr Jaafar Heikel", role: "Vice-Président", specialty: "Nutritionniste & Épidémiologiste", desc: "Professeur d'université, consultant international et expert en politiques de santé. Apporte une vision stratégique et populationnelle." },
                    { name: "Pr El Harti Amine", role: "Secrétaire Général", specialty: "Professeur Agrégé en chirurgie plastique et esthétique", desc: "Enseignant à la faculté de Médecine de Casablanca. Membre du Groupe d’experts National pour la formation de spécialisation. Contribue à la structuration des protocoles cliniques et au lien académique." },
                    { name: "Dr Karim Benjelloun", role: "Trésorier", specialty: "Anesthésiste-Réanimateur", desc: "Son expertise en anesthésie et alimentation thérapeutique renforce la prise en charge globale." },
                    { name: "Dr Raghni Salwa", role: "Assesseur 1", specialty: "Médecin Généraliste", desc: "En charge du repérage précoce et de l'orientation diagnostique des patientes en première ligne de soins." },
                    { name: "Dr Belmallem Imane", role: "Assesseur 2", specialty: "Pneumologue & Allergologue", desc: "Spécialisée dans les troubles respiratoires et inflammatoires. Contribue à l'analyse des comorbidités associées." },
                    { name: "Dr Mohammed Taha", role: "Assesseur 3", specialty: "Médecin du Sport", desc: "Conçoit des programmes d'activité physique adaptée (APA) pour les patientes atteintes de lipœdème." }
                ]
            },
            stats: {
                title: "Statuts de l'Association",
                subtitle: "Consultez et téléchargez les statuts officiels de la Société Marocaine du Lipœdème",
                description: "Les statuts complets de MOSLIPOD détaillent la gouvernance, les objectifs, les droits et obligations des membres, ainsi que toutes les dispositions réglementaires de l'association.",
                cta: "Télécharger les Statuts (PDF)",
                info: "Format PDF • Mise à jour 2025 • Disponible immédiatement"
            },
            cta: {
                title: "Rejoignez Notre Mission",
                subtitle: "Que vous soyez professionnel de santé, patient ou simplement intéressé par notre cause, découvrez comment vous pouvez soutenir MOSLIPOD",
                button1: "Découvrir MOSLIPOD",
                button2: "Retourner à l'accueil"
            }
        },
        lipoedeme: {
            hero: {
                badge: "Comprendre la pathologie",
                title: "Le Lipœdème",
                subtitle: "Une pathologie chronique, évolutive et invalidante qui demande une prise en charge globale et bienveillante"
            },
            definition: {
                title: "Qu'est-ce que le Lipœdème ?",
                p1: "Le lipœdème est une pathologie chronique, évolutive et encore méconnue, caractérisée par une accumulation excessive de tissu adipeux sous-cutané, principalement localisée au niveau des hanches, des cuisses, des genoux, des jambes, et parfois des bras.",
                p1High: " excessive de tissu adipeux sous-cutané",
                p2: "Contrairement à l'obésité, cette accumulation est symétrique, douloureuse, non influencée par la restriction calorique, et n'affecte pas les extrémités (mains ou pieds).",
                p2High: "symétrique, douloureuse, non influencée par la restriction calorique",
                omsTitle: "Reconnaissance OMS",
                omsDesc: "Reconnu par l'OMS depuis 1945 comme une affection invalidante, il touche quasiment exclusivement les femmes, souvent après un déséquilibre hormonal (puberté, grossesse, ménopause). Malgré cela, il reste largement sous-diagnostiqué dans la pratique clinique.",
                omsHigh: " sous-diagnostiqué"
            },
            symptoms: {
                title: "Les Symptômes",
                subtitle: "Reconnaître les manifestations cliniques du lipœdème pour une prise en charge précoce",
                items: [
                    { title: "Douleurs spontanées ou à la pression", desc: "Inconfort dans les zones affectées, indépendant de l'activité physique" },
                    { title: "Sensation de jambes lourdes", desc: "Sensation de tension persistante, même au repos" },
                    { title: "Formation fréquente d'ecchymoses", desc: "Fragilité capillaire sans traumatisme évident" },
                    { title: "Aspect nodulaire du tissu adipeux", desc: "Structure irrégulière et déformation" },
                    { title: "Disproportion marquée", desc: "Entre le tronc (souvent mince) et les membres inférieurs et parfois supérieurs" },
                    { title: "Résistance aux régimes", desc: "Pas d'amélioration malgré les efforts diététiques et l'exercice" }
                ],
                psych: {
                    title: "Impact Psychologique",
                    desc: "Les patientes évoquent souvent un impact psychologique important : isolement, anxiété, baisse de l'estime de soi. Une prise en charge bienveillante et multidisciplinaire est essentielle.",
                    high: "multidisciplinaire"
                }
            },
            treatments: {
                title: "Approches Thérapeutiques",
                subtitle: "Des solutions non chirurgicales adaptées à votre situation",
                conservative: [
                    { title: "Activité physique adaptée", desc: "Marche aquatique, vélo, Pilates doux" },
                    { title: "Vêtements compressifs", desc: "Bas ou leggings de contention médicale" },
                    { title: "Drainage lymphatique manuel", desc: "Par un professionnel formé (DLM)" },
                    { title: "Pressothérapie intermittente", desc: "Stimulation de la circulation" },
                    { title: "Cryothérapie localisée", desc: "En centre spécialisé" },
                    { title: "Régime anti-inflammatoire", desc: "Réduction sucre, aliments transformés, oméga-3" }
                ],
                surgical: {
                    title: "Approches Chirurgicales",
                    p1: "Il n'existe pas de traitement curatif définitif. Cependant, pour les formes sévères, une liposuccion médicale spécialisée peut être envisagée, réservée aux centres experts et encadrée par un suivi pluridisciplinaire.",
                    p1High1: "formes sévères",
                    p1High2: " suivi pluridisciplinaire",
                    p2: "Cette approche utilise des techniques douces (sous tumescence ou jet d'eau) et doit être accompagnée d'une prise en charge intégrative incluant médecins généralistes, spécialistes vasculaires, kinésithérapeutes, nutritionnistes, et psychologues."
                }
            },
            stages: {
                title: "Les Stades du Lipœdème",
                items: [
                    { title: "Stade 1", desc: "La surface de la peau est lisse. Le tissu adipeux sous-cutané est épaissi, mais la structure est souple." },
                    { title: "Stade 2", desc: "La surface de la peau devient irrégulière. Le tissu adipeux présente un aspect nodulaire (peau d'orange)." },
                    { title: "Stade 3", desc: "Accumulation importante de tissu adipeux. Larges lobes de graisse déformants surtout aux hanches et aux genoux." }
                ]
            },
            cta: {
                title: "Vous n'êtes pas seul(e)",
                subtitle: "MOSLIPOD est là pour vous accompagner, vous informer et vous orienter vers les ressources adaptées. Contactez-nous pour en savoir plus sur les options de traitement et les centres spécialisés.",
                button1: "Nous Contacter",
                button2: "Adhérer à MOSLIPOD"
            }
        },
        actions: {
            hero: {
                badge: "Notre Engagement",
                title: "Nos Actions pour le Changement",
                subtitle: "Trois axes majeurs pour transformer la reconnaissance et la prise en charge du lipœdème à l'échelle nationale"
            },
            discoverMore: "Découvrir plus",
            items: [
                {
                    title: "Sensibilisation",
                    description: "Campagne d'information du grand public et des professionnels",
                    details: [
                        "Diffusion de contenus éducatifs fiables",
                        "Déconstruction des idées reçues",
                        "Partenariats avec institutions médicales",
                        "Supports ciblés pour les professionnels"
                    ]
                },
                {
                    title: "Formation",
                    description: "Journée de formation médicale continue en 2026",
                    details: [
                        "Formation des médecins généralistes",
                        "Outils cliniques pratiques",
                        "Présentation des critères diagnostiques",
                        "Échange d'expériences et réseautage"
                    ]
                },
                {
                    title: "Information",
                    description: "Création et diffusion d'outils pour les soignants",
                    details: [
                        "Fiches pratiques de diagnostic",
                        "Supports de formation continue",
                        "Vidéos et infographies",
                        "Guides pour cabinets médicaux"
                    ]
                }
            ],
            stats: [
                { number: "2025", label: "Année de fondation" },
                { number: "7", label: "Experts fondateurs" },
                { number: "3", label: "Axes d'action" }
            ],
            cta: {
                title: "Impliquez-vous dans Notre Mission",
                subtitle: "Rejoignez notre communauté de professionnels engagés pour transformer la reconnaissance et la prise en charge du lipœdème",
                button1: "Devenir membre",
                button2: "Nous contacter"
            }
        },
        membership: {
            hero: {
                badge: "Rejoignez notre communauté",
                title: "Devenez Membre de MOSLIPOD",
                subtitle: "Rejoignez notre communauté de professionnels de santé engagés dans la reconnaissance, la recherche et la prise en charge du lipœdème"
            },
            learnMore: "En savoir plus",
            intro: "MOSLIPOD est ouverte aux professionnels de santé marocains et étrangers souhaitant s'engager dans la reconnaissance, la recherche et la prise en charge du lipœdème.",
            types: {
                title: "Types de Membres",
                active: {
                    name: "Membres Actifs",
                    badge: "Principal",
                    requirements: [
                        "Être inscrit au Conseil de l'Ordre des Médecins (Maroc)",
                        "Être parrainé par deux membres actifs",
                        "Adhérer aux statuts et règlement",
                        "Être agréé et élu en Assemblée Générale",
                        "S'acquitter de la cotisation annuelle"
                    ]
                },
                candidate: {
                    name: "Membres Candidats",
                    badge: "Accès",
                    requirements: [
                        "Jeunes médecins souhaitant rejoindre",
                        "Être inscrit à l'Ordre des Médecins",
                        "Être parrainé par deux membres",
                        "Statut valable jusqu'à 5 ans maximum",
                        "Peut évoluer vers membre actif"
                    ]
                },
                honorary: {
                    name: "Membres Honoraires",
                    badge: "Honneur",
                    requirements: [
                        "Anciens membres ayant cessé activité",
                        "Sur demande écrite parrainée",
                        "Approuvé par vote (majorité 2/3)",
                        "Exonéré de cotisation",
                        "Sans droit de vote"
                    ]
                },
                foreign: {
                    name: "Membres Étrangers",
                    badge: "International",
                    requirements: [
                        "Professionnels de santé étrangers",
                        "Membres de leur société nationale",
                        "Activité liée au lipœdème",
                        "Parrainés par membres depuis 5+ ans",
                        "Engagement envers la charte"
                    ]
                }
            },
            process: {
                title: "Processus d'Adhésion",
                steps: [
                    { title: "Candidature", desc: "Soumettez votre dossier complet selon les modalités" },
                    { title: "Parrainage", desc: "Obtenez le soutien de deux membres actifs" },
                    { title: "Comité", desc: "Examen de votre candidature par le Comité" },
                    { title: "Assemblée", desc: "Vote d'élection en Assemblée Générale" },
                    { title: "Confirmation", desc: "Bienvenue en tant que membre de MOSLIPOD !" }
                ]
            },
            cta: {
                title: "Prêt à nous rejoindre ?",
                subtitle: "Contactez-nous pour obtenir plus d'informations sur les modalités d'adhésion et commencez votre parcours avec nous",
                button1: "Nous Contacter",
                button2: "Retour à l'accueil"
            }
        },
        contactPage: {
            hero: {
                badge: "Parlons-en",
                title: "Contactez-nous",
                subtitle: "Notre équipe est là pour répondre à vos questions et vous accompagner. N'hésitez pas à nous solliciter."
            },
            form: {
                firstName: "Prénom *",
                lastName: "Nom *",
                organisation: "Organisation",
                countryCode: "Indicatif *",
                phone: "Téléphone *",
                email: "Email *",
                subject: "Objet *",
                message: "Message *",
                send: "Envoyer le Message",
                newsletter: "J'accepte de recevoir la Newsletter de l'association",
                submit: "Envoyer le Message",
                sending: "Envoi en cours...",
                success: "Message envoyé ! Nous reviendrons vers vous rapidement."
            },
            info: {
                title: "Coordonnées",
                subtitle: "Les moyens directs pour joindre notre association",
                addressTitle: "Notre Siège",
                phoneTitle: "Téléphone",
                emailTitle: "Email"
            }
        },
        privacy: {
            title: "Politique de Confidentialité",
            subtitle: "Dernière mise à jour : Fév 2026",
            intro: "Chez MOSLIPOD, nous accordons une grande importance à la protection de vos données personnelles. Cette politique détaille comment nous collectons, utilisons et protégeons vos informations.",
            collection: {
                title: "Collecte des Données",
                content: "Nous collectons les informations que vous nous fournissez directement (nom, email, etc.) lorsque vous remplissez des formulaires ou vous inscrivez à notre newsletter."
            },
            usage: {
                title: "Utilisation des Données",
                content: "Vos données sont utilisées pour communiquer avec vous, gérer votre adhésion et vous envoyer des informations sur nos activités."
            },
            protection: {
                title: "Protection des Données",
                content: "Nous mettons en œuvre des mesures de sécurité pour protéger vos données contre tout accès non autorisé ou divulgation."
            },
            rights: {
                title: "Vos Droits",
                content: "Vous avez le droit d'accéder, de corriger ou de supprimer vos données personnelles. Contactez-nous à Lipoedememaroc@gmail.com pour toute demande."
            }
        },
        legal: {
            title: "Mentions Légales",
            subtitle: "Informations Générales",
            editor: {
                title: "Éditeur du Site",
                content: "MOSLIPOD (Société Marocaine du Lipœdème)\n7, rue Ahmed Annaciri – Palmier\n20100 Casablanca\nMaroc\nEmail : Lipoedememaroc@gmail.com\nTéléphone : +212 6 66 01 39 59"
            },
            hosting: {
                title: "Hébergement",
                content: "Ce site est hébergé par KYBOHO, situé au 44 Avenue Mohammed Ben Abdellah, Fès."
            },
            ip: {
                title: "Propriété Intellectuelle",
                content: "Tout le contenu de ce site (textes, images, logos) est la propriété de MOSLIPOD ou de ses partenaires et est protégé par les lois sur le droit d'auteur."
            }
        }
    },
    ar: {
        nav: {
            home: "الرئيسية",
            about: "عن الجمعية",
            lipoedeme: "الوذمة الشحمية",
            actions: "أعمالنا",
            adhesion: "العضوية",
            news: "أخبار",
            contact: "اتصل بنا"
        },
        newsPage: {
            title: "أخبار",
            comingSoon: "قريباً",
            description: "نحن نعمل حاليًا على هذه الصفحة لنجلب لك آخر الأخبار والتحديثات حول الوذمة الشحمية. ابقوا على اطلاع!",
            backHome: "العودة للرئيسية"
        },
        footer: {
            address: "7, rue Ahmed Annaciri – Palmier, 20100 Casablanca",
            email: "Lipoedememaroc@gmail.com",
            phone: "+212 6 66 01 39 59",
            rights: "© {year} MOSLIPOD. جميع الحقوق محفوظة."

        },
        home: {
            hero: {
                badge: "التعريف • التكفل • التوعية",
                title1: "التعريف بـ",
                title2: "الوذمة الشحمية",
                description: "تعمل الجمعية المغربية للوذمة الشحمية على التعريف والتكفل والتوعية بمرض مزمن معترف به من قبل منظمة الصحة العالمية منذ عام 1945 يصيب حوالي 11% من السكان، معظمهم من النساء.",
                cta1: "اكتشف الوذمة الشحمية",
                cta2: "من نحن؟"
            },
            whatIs: {
                title: "ما هي الوذمة الشحمية؟",
                subtitle: "حالة مزمنة، متطورة وغالباً ما يتم تشخيصها بشكل خاطئ",
                cards: {
                    sym: "تراكم\nمتماثل",
                    pain: "مؤلمة\nعند اللمس",
                    weight: "لا تتأثر\nبالوزن",
                    spared: "اليدين والقدمين\nسليمة"
                },
                description: "تتميز الوذمة الشحمية بتراكم مرضي للأنسجة الدهنية تحت الجلد، تتركز بشكل أساسي في الأطراف السفلية. تتطور هذه الحالة ببطء وتصيب حوالي 11% من سكان العالم، معظمهم من النساء.",
                cta: "اعرف المزيد"
            }
        },
        about: {
            hero: {
                badge: "تأسست في 2025 بالدار البيضاء",
                title: "عن MOSLIPOD",
                subtitle: "جمعية طبية غير ربحية مكرسة للتعريف والتدريب المهني والتوعية حول الوذمة الشحمية"
            },
            genesis: {
                title: "النشأة",
                content: [
                    "تأسست الجمعية المغربية للوذمة الشحمية والأمراض المرتبطة بها في عام 2025 بالدار البيضاء، وهي جمعية طبية غير ربحية تعمل على الاعتراف العلمي والتدريب المهني وتوعية الجمهور وتحسين التكفل بالمرضى.",
                    "ولدت هذه الجمعية العلمية بدفع من الدكتور فهد بنسليمان، جراح التجميل الذي يعالج منذ أكثر من عقدين مريضات تظهر عليهن أعراض الوذمة الشحمية، قبل فترة طويلة من تحديد المرض رسمياً.",
                    "وإدراكاً منها للتعقيد متعدد الأبعاد لهذا المرض — الالتهابي والأيضي والوعائي والغذائي والنفسي — ضمت الجمعية مجمعاً متعدد التخصصات من الأطباء والخبراء الملتزمين بنهج تكاملي يقوم على التوصيات الدولية."
                ],
                year: "2025",
                yearTitle: "سنة التأسيس",
                location: "الدار البيضاء، المغرب"
            },
            objectives: {
                title: "أهدافنا الستة الرئيسية",
                subtitle: "خارطة طريق طموحة لإحداث ثورة في التكفل بالوذمة الشحمية",
                items: [
                    { title: "الإعلام والتوعية", desc: "إعلام السكان المغاربة بالوذمة الشحمية باستخدام أدوات تعليمية علمية. التعريف بهذا المرض المعترف به من قبل منظمة الصحة العالمية منذ عام 1945." },
                    { title: "تعزيز التكفل بالمرضى", desc: "تشجيع اتباع نهج مبكر ومتعدد التخصصات وتكاملي يقوم على علاجات غير جراحية معتمدة." },
                    { title: "التدريب والتواصل", desc: "تدريب المهنيين الصحيين في القطاعين العام والخاص لتجنب المضاعفات." },
                    { title: "البحث والخبرة", desc: "قيادة أو المشاركة في دراسات سريرية ووبائية وتقديم خبرات علمية." },
                    { title: "التعاون والمرافعة", desc: "التعاون مع الوزارات ومنظمات الصحة الوطنية والدولية من أجل السياسات العامة." },
                    { title: "الفعاليات والمنشورات", desc: "تنظيم مؤتمرات ودورات تدريبية ونشر كتيبات ومنشورات ودعائم علمية." }
                ]
            },
            team: {
                title: "أعضاء المكتب التأسيسي",
                subtitle: "فريق من الأطباء والخبراء الملتزمين بنهج متعدد التخصصات",
                members: [
                    { name: "د. فهد بنسليمان", role: "الرئيس", specialty: "جراح تجميل", desc: "خبير في جراحة التجميل والترميم. مؤسس الجمعية، ومعروف بالتزامه بالتعريف بالوذمة الشحمية." },
                    { name: "أ. جعفر هيكل", role: "نائب الرئيس", specialty: "خبير تغذية ووبائيات", desc: "أستاذ جامعي، استشاري دولي وخبير في السياسات الصحية. يقدم رؤية استراتيجية ووبائية." },
                    { name: "أ. الحارتي أمين", role: "الكاتب العام", specialty: "أستاذ مبرز في جراحة التجميل والترميم", desc: "بكلية الطب بالدار البيضاء. عضو في الفريق الوطني للخبراء لتكوين التخصص. يساهم في هيكلة البروتوكولات السريرية والرابط الأكاديمي." },
                    { name: "د. كريم بنجلون", role: "أمين المال", specialty: "طبيب تخدير وعناية مركزة", desc: "خبرته في التخدير والتغذية العلاجية تعزز التكفل الشامل بالمرضى." },
                    { name: "د. رغني سلوى", role: "المستشار 1", specialty: "طب عام", desc: "مسؤولة عن الكشف المبكر والتشخيص للمريضات في الخط الأول من الرعاية." },
                    { name: "د. بلمعلم إيمان", role: "المستشار 2", specialty: "طبيبة أمراض صدرية وحساسية", desc: "متخصصة في الاضطرابات التنفسية والالتهابية. تساهم في تحليل الأمراض المصاحبة." },
                    { name: "د. محمد طه", role: "المستشار 3", specialty: "طب رياضي", desc: "يصمم برامج النشاط البدني المكيف (APA) للمريضات المصابات بالوذمة الشحمية." }
                ]
            },
            stats: {
                title: "القانون الأساسي للجمعية",
                subtitle: "اطلع على القانون الأساسي الرسمي للجمعية المغربية للوذمة الشحمية وقم بتحميله",
                description: "يفصل القانون الأساسي الكامل لـ MOSLIPOD الحكامة والأهداف وحقوق وواجبات الأعضاء، وكافة الأحكام التنظيمية للجمعية.",
                cta: "تحميل القانون الأساسي (PDF)",
                info: "صيغة PDF • تحديث 2025 • متاح فوراً"
            },
            cta: {
                title: "انضم إلى مهمتنا",
                subtitle: "سواء كنت مهنياً صحياً أو مريضاً أو مهتماً بقضيتنا، اكتشف كيف يمكنك دعم MOSLIPOD",
                button1: "انضم إلى MOSLIPOD",
                button2: "العودة إلى الرئيسية"
            }
        },
        lipoedeme: {
            hero: {
                badge: "فهم المرض",
                title: "الوذمة الشحمية",
                subtitle: "مرض مزمن ومتطور ومسبب للعجز يتطلب تكفلاً شاملاً ورحيماً"
            },
            definition: {
                title: "ما هي الوذمة الشحمية؟",
                p1: "الوذمة الشحمية هي مرض مزمن ومتطور ولا يزال يساء فهمه، ويتميز بتراكم مفرط للأنسجة الدهنية تحت الجلد، ويتركز بشكل أساسي في الوركين والفخذين والركبتين والساقين، وأحياناً الذراعين.",
                p1High: "مفرط للأنسجة الدهنية تحت الجلد",
                p2: "على عكس السمنة، يكون هذا التراكم متناظراً، ومؤلماً، ولا يتأثر بتقليل السعرات الحرارية، ولا يؤثر على الأطراف (اليدين أو القدمين).",
                p2High: "متناظراً، ومؤلماً، ولا يتأثر بتقليل السعرات الحرارية",
                omsTitle: "اعتراف منظمة الصحة العالمية",
                omsDesc: "معترف بها من قبل منظمة الصحة العالمية منذ عام 1945 كحالة مسببة للعجز، وهي تصيب النساء حصرياً تقريباً، غالباً بعد اضطراب هرموني (البلوغ، الحمل، سن اليأس). وعلى الرغم من ذلك، لا تزال تعاني بشكل كبير من نقص التشخيص في الممارسة السريرية.",
                omsHigh: "نقص التشخيص"
            },
            symptoms: {
                title: "الأعراض",
                subtitle: "التعريف بالمظاهر السريرية للوذمة الشحمية من أجل التكفل المبكر بها",
                items: [
                    { title: "آلام تلقائية أو عند الضغط", desc: "انزعاج في المناطق المصابة، بشكل مستقل عن النشاط البدني" },
                    { title: "الشعور بثقل الساقين", desc: "شعور بالتوتر المستمر، حتى في وقت الراحة" },
                    { title: "ظهور كدمات متكررة", desc: "هشاشة الشعيرات الدموية دون تعرض واضح للصدمات" },
                    { title: "المظهر العُقَدي للنسيج الدهني", desc: "بنية غير منتظمة وتشوه في الشكل" },
                    { title: "عدم تناسق واضح", desc: "بين الجذع (الذي غالباً ما يكون نحيفاً) والأطراف السفلية وأحياناً العلوية" },
                    { title: "مقاومة الحمية الغذائية", desc: "لا يوجد تحسن رغم الجهود الغذائية وممارسة الرياضة" }
                ],
                psych: {
                    title: "التأثير النفسي",
                    desc: "غالباً ما تذكر المريضات تأثيراً نفسياً كبيراً: العزلة، القلق، انخفاض تقدير الذات. إن التكفل الرحيم ومتعدد التخصصات أمر ضروري.",
                    high: "متعدد التخصصات"
                }
            },
            treatments: {
                title: "النهج العلاجي",
                subtitle: "حلول غير جراحية مكيفة حسب حالتك",
                conservative: [
                    { title: "النشاط البدني المكيف", desc: "المشي المائي، ركوب الدراجات، بيلاتيس لطيف" },
                    { title: "الملابس الضاغطة", desc: "جوارب أو طماق ضغط طبي" },
                    { title: "التصريف اللمفاوي اليدوي", desc: "من قبل متخصص مدرب (DLM)" },
                    { title: "العلاج بالضغط المتقطع", desc: "تحفيز الدورة الدموية" },
                    { title: "العلاج بالتبريد الموضعي", desc: "في مراكز متخصصة" },
                    { title: "حمية مضادة للالتهابات", desc: "تقليل السكر، الأطعمة المصنعة، أوميغا 3" }
                ],
                surgical: {
                    title: "النهج الجراحي",
                    p1: "لا يوجد علاج جذري نهائي. ومع ذلك، بالنسبة للأشكال الشديدة، يمكن النظر في جراحة شفط الدهون الطبية المتخصصة، والمخصصة للمراكز الخبيرة والمحاطة بمتابعة متعددة التخصصات.",
                    p1High1: "الأشكال الشديدة",
                    p1High2: "متابعة متعددة التخصصات",
                    p2: "يستخدم هذا النهج تقنيات لطيفة (تحت التخدير الموضعي أو نفث الماء) ويجب أن يصاحبه تكفل تكاملي يشمل أطباء عامين، أخصائيي الأوعية الدموية، أخصائيي العلاج الطبيعي، أخصائيي التغذية، وأطباء نفسيين."
                }
            },
            stages: {
                title: "مراحل الوذمة الشحمية",
                items: [
                    { title: "المرحلة الأولى", desc: "سطح الجلد أملس. الأنسجة الدهنية تحت الجلد سميكة، لكن البنية لينة." },
                    { title: "المرحلة الثانية", desc: "يصبح سطح الجلد غير منتظم. الأنسجة الدهنية لها مظهر عقدي (قشر البرتقال)." },
                    { title: "المرحلة الثالثة", desc: "تراكم كبير للأنسجة الدهنية. فصوص دهنية كبيرة ومشوهة خاصة عند الوركين والركبتين." }
                ]
            },
            cta: {
                title: "لستِ وحدكِ",
                subtitle: "MOSLIPOD هنا لمرافقتكِ وإعلامكِ وتوجيهكِ نحو الموارد المناسبة. اتصلي بنا لمعرفة المزيد عن خيارات العلاج والمراكز المتخصصة.",
                button1: "اتصلي بنا",
                button2: "انضمي إلى MOSLIPOD"
            }
        },
        actions: {
            hero: {
                badge: "التزامنا",
                title: "أعمالنا من أجل التغيير",
                subtitle: "ثلاثة محاور رئيسية لتحويل الاعتراف بالوذمة الشحمية والتكفل بها على المستوى الوطني"
            },
            discoverMore: "اكتشف المزيد",
            items: [
                {
                    title: "التحسيس",
                    description: "حملة إعلامية للجمهور والمهنيين",
                    details: [
                        "نشر محتوى تعليمي موثوق",
                        "تفكيك الأفكار المغلوطة",
                        "شراكات مع المؤسسات الطبية",
                        "دعائم مستهدفة للمهنيين"
                    ]
                },
                {
                    title: "التكوين",
                    description: "يوم التكوين الطبي المستمر في عام 2026",
                    details: [
                        "تكوين الأطباء العامين",
                        "أدوات سريرية عملية",
                        "عرض معايير التشخيص",
                        "تبادل الخبرات والتواصل"
                    ]
                },
                {
                    title: "الإعلام",
                    description: "إنشاء ونشر أدوات لمقدمي الرعاية",
                    details: [
                        "بطاقات تشخيصية عملية",
                        "دعائم التكوين المستمر",
                        "فيديوهات ورسوم بيانية",
                        "أدلة للعيادات الطبية"
                    ]
                }
            ],
            stats: [
                { number: "2025", label: "سنة التأسيس" },
                { number: "7", label: "خبراء مؤسسون" },
                { number: "3", label: "محاور العمل" }
            ],
            cta: {
                title: "شارك في مهمتنا",
                subtitle: "انضم إلى مجتمعنا من المهنيين الملتزمين بتحويل الاعتراف بالوذمة الشحمية والتكفل بها",
                button1: "كن عضواً",
                button2: "اتصل بنا"
            }
        },
        membership: {
            hero: {
                badge: "انضم إلى مجتمعنا",
                title: "كن عضواً في MOSLIPOD",
                subtitle: "انضم إلى مجتمعنا من المهنيين الصحيين الملتزمين بالاعتراف بالوذمة الشحمية والبحث فيها والتكفل بها"
            },
            learnMore: "اعرف المزيد",
            intro: "تفتح MOSLIPOD أبوابها للمهنيين الصحيين المغاربة والأجانب الراغبين في الالتزام بالاعتراف بالوذمة الشحمية والبحث فيها والتكفل بها.",
            types: {
                title: "أنواع العضوية",
                active: {
                    name: "أعضاء عاملون",
                    badge: "رئيسي",
                    requirements: [
                        "المسؤولية في مجلس هيئة الأطباء (المغرب)",
                        "تزكية من قبل عضوين عاملين",
                        "الالتزام بالقوانين والأنظمة",
                        "الموافقة والانتخاب في الجمعية العمومية",
                        "أداء واجب الاشتراك السنوي"
                    ]
                },
                candidate: {
                    name: "أعضاء مرشحون",
                    badge: "ولوج",
                    requirements: [
                        "الأطباء الشباب الراغبين في الانضمام",
                        "التسجيل في هيئة الأطباء",
                        "تزكية من قبل عضوين",
                        "الوضع صالح لمدة تصل إلى 5 سنوات كحد أقصى",
                        "يمكن أن يتطور إلى عضو عامل"
                    ]
                },
                honorary: {
                    name: "أعضاء فخريون",
                    badge: "شرف",
                    requirements: [
                        "الأعضاء السابقون الذين توقفوا عن النشاط",
                        "بناءً على طلب كتابي مزكى",
                        "الموافقة بالتصويت (أغلبية الثلثين)",
                        "الإعفاء من واجب الاشتراك",
                        "بدون حق التصويت"
                    ]
                },
                foreign: {
                    name: "أعضاء أجانب",
                    badge: "دولي",
                    requirements: [
                        "المهنيون الصحيون الأجانب",
                        "أعضاء في جمعيتهم الوطنية",
                        "نشاط متعلق بالوذمة الشحمية",
                        "مزكون من قبل أعضاء لمدة تزيد عن 5 سنوات",
                        "الالتزام بالميثاق"
                    ]
                }
            },
            process: {
                title: "عملية الانضمام",
                steps: [
                    { title: "طلب الترشيح", desc: "تقديم ملفك الكامل وفقاً للإجراءات" },
                    { title: "التزكية", desc: "الحصول على دعم عضوين عاملين" },
                    { title: "اللجنة", desc: "فحص طلبك من قبل اللجنة" },
                    { title: "الجمعية العمومية", desc: "التصويت على الانتخاب في الجمعية العمومية" },
                    { title: "التأكيد", desc: "مرحباً بك كعضو في MOSLIPOD!" }
                ]
            },
            cta: {
                title: "هل أنت مستعد للانضمام إلينا؟",
                subtitle: "اتصل بنا للحصول على مزيد من المعلومات حول إجراءات الانضمام وابدأ رحلتك معنا",
                button1: "اتصل بنا",
                button2: "العودة إلى الرئيسية"
            }
        },
        privacy: {
            title: "سياسة الخصوصية",
            subtitle: "آخر تحديث: فبراير 2026",
            intro: "في MOSLIPOD، نولي أهمية كبيرة لحماية بياناتك الشخصية. توضح هذه السياسة كيفية جمعنا واستخدامنا وحمايتنا لمعلوماتك.",
            collection: {
                title: "جمع البيانات",
                content: "نجمع المعلومات التي تقدمها لنا مباشرة (الاسم، البريد الإلكتروني، إلخ) عند ملء النماذج أو الاشتراك في نشرتنا الإخبارية."
            },
            usage: {
                title: "استخدام البيانات",
                content: "تُستخدم بياناتك للتواصل معك، وإدارة عضويتك، وإرسال معلومات حول أنشطتنا."
            },
            protection: {
                title: "حماية البيانات",
                content: "نحن نطبق إجراءات أمنية لحماية بياناتك من الوصول غير المصرح به أو الكشف عنها."
            },
            rights: {
                title: "حقوقك",
                content: "لديك الحق في الوصول إلى بياناتك الشخصية أو تصحيحها أو حذفها. اتصل بنا على Lipoedememaroc@gmail.com لأي طلب."
            }
        },
        legal: {
            title: "إشعار قانوني",
            subtitle: "معلومات عامة",
            editor: {
                title: "ناشر الموقع",
                content: "MOSLIPOD (الجمعية المغربية للوذمة الشحمية)\n7، شارع أحمد الناصري – بالمي\n20100 الدار البيضاء\nالمغرب\nالبريد الإلكتروني: Lipoedememaroc@gmail.com\nالهاتف: +212 6 66 01 39 59"
            },
            hosting: {
                title: "الاستضافة",
                content: "تتم استضافة هذا الموقع بواسطة KYBOHO، ومقره 44 شارع محمد بن عبد الله، فاس."
            },
            ip: {
                title: "الملكية الفكرية",
                content: "جميع محتويات هذا الموقع (نصوص، صور، شعارات) هي ملك لـ MOSLIPOD أو شركائها ومحمية بموجب قوانين حقوق النشر."
            }
        },
        contactPage: {
            hero: {
                badge: "دعونا نتحدث",
                title: "اتصل بنا",
                subtitle: "فريقنا هنا للإجابة على أسئلتكم ومرافقتكم. لا تترددوا في التواصل معنا."
            },
            form: {
                firstName: "الاسم الأول *",
                lastName: "الاسم الأخير *",
                organisation: "المؤسسة",
                countryCode: "الرمز *",
                phone: "الهاتف *",
                email: "البريد الإلكتروني *",
                subject: "الموضوع *",
                message: "الرسالة *",
                send: "إرسال الرسالة",
                newsletter: "أوافق على تلقي النشرة الإخبارية للجمعية",
                submit: "إرسال الرسالة",
                sending: "جاري الإرسال...",
                success: "تم إرسال الرسالة! سنرد عليك قريباً."
            },
            info: {
                title: "معلومات الاتصال",
                subtitle: "وسائل التواصل المباشرة مع جمعيتنا",
                addressTitle: "مقرنا",
                phoneTitle: "الهاتف",
                emailTitle: "البريد الإلكتروني"
            }
        }
    }
};

// Fonction de traduction qui prend une clé et renvoie la traduction dans la langue spécifiée
export const t = (key, language = 'fr') => {
    if (!translations[language]) {
        console.warn(`Language '${language}' not found, falling back to French`);
        language = 'fr';
    }

    // Handle nested keys like 'nav.home'
    const keys = key.split('.');
    let translation = translations[language];

    for (const k of keys) {
        if (translation && translation[k]) {
            translation = translation[k];
        } else {
            console.warn(`Translation key '${key}' not found in '${language}'`);
            // Fallback to English if not found in current language
            if (language !== 'en') {
                return t(key, 'en');
            }
            return key;
        }
    }

    return translation;
};

export default translations;
